import { ArrowUpDownIcon, ChevronDownIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu'
import { SORT_LABEL, findSortOption } from '@/lib/sort'
import type { SortOption } from '@/lib/sort'

interface SortMenuProps<TSort extends string> {
  value: TSort
  options: SortOption<TSort>[]
  onChange: (next: TSort) => void
}

export function SortMenu<TSort extends string>({ value, options, onChange }: SortMenuProps<TSort>): React.ReactElement {
  const currentLabel = findSortOption(options, value)?.label ?? SORT_LABEL

  const handleValueChange = (next: string): void => {
    const option = findSortOption(options, next)

    if (option === undefined) return

    onChange(option.value)
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
        >
          <ArrowUpDownIcon />
          {currentLabel}
          <ChevronDownIcon className="opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="w-48"
      >
        <DropdownMenuLabel>{SORT_LABEL}</DropdownMenuLabel>
        <DropdownMenuRadioGroup
          value={value}
          onValueChange={handleValueChange}
        >
          {options.map((option) => (
            <DropdownMenuRadioItem
              key={option.value}
              value={option.value}
            >
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
